// extracted by mini-css-extract-plugin
module.exports = {"blockCommon":"common-styles__blockCommon___37uNn","commonCloseButton":"common-styles__commonCloseButton___15kBr","overlayDrawer":"common-styles__overlayDrawer___VsbP6"};